import { HtmlElementProps } from "../../types/globals";
import { BreakpointOptions } from "../../types/theming";

export type ViewportOperatorOptions = "is" | "greaterThan" | "lessThan";

export type ViewportScaleValue = {
	[key in BreakpointOptions]: number;
};

export const ViewportScale: ViewportScaleValue = {
	xs: 10,
	sm: 20,
	md: 30,
	lg: 40,
	xl: 50,
	xxl: 60,
} as const;

export type MediaResult = {
	query: MediaQueryList;
	breakpoint: BreakpointOptions;
};

export type ViewportState = {
	[key in BreakpointOptions]: boolean;
};

export type Viewport = {
	[key in ViewportOperatorOptions]: ViewportState;
};

export type ViewportResult = Viewport & {
	currentSize: BreakpointOptions;
};

/**
 * Context Props
 */
export type ViewportSsrContextProps = HtmlElementProps & {
	/**
	 * Sets a breakpoint, preferably the 'current' viewport breakpoint value. Useful for initial server-side
	 * rendering when server side components need to render responsively.
	 */
	breakpoint: BreakpointOptions;
};
